import { Modal, Typography } from "antd";
import React from "react";
import CustomButton from "../../resuableComponents/CustomButton";
import "./confirmationModal.css"

const ConfirmationModal = ({
    icon,
    title,
    desc,
    showModal,
    primaryOnClick,
    secondaryOnClick,
    primaryBtnText,
    secondaryBtnText,
    showSecondaryButton,
    showPrimaryButton = true,
    deleteInstrumentsLoading,
}) => {
    return (
        <Modal
            centered
            open={showModal}
            footer={null}
            closable={false}
            width={"416px"}
        >
            <div className="domestic-error-root">
                <div className="domestic-error-header-conatiner">
                    <div className="domestic-error-header-logo">{icon}</div>
                    <div className="domestic-error-header-content dynamic-font-styling">
                        <Typography className="domestic-error-header-title">
                            {title}
                        </Typography>
                        <Typography
                            className="domestic-error-header-desc"
                            style={{ whiteSpace: "pre-wrap" }}
                        >
                            {desc}
                        </Typography>
                    </div>
                </div>
                <div className="domestic-error-footer">
                    {showSecondaryButton && (
                        <CustomButton
                            buttonType={"primary-btn"}
                            containerType={""}
                            padding={"5px 15px"}
                            onClick={secondaryOnClick}
                            text={secondaryBtnText}
                        />
                    )}
                    {
                        showPrimaryButton && (
                            <CustomButton
                                loading={deleteInstrumentsLoading}
                                text={primaryBtnText}
                                buttonType={"primary-btn"}
                                padding={"5px 15px"}
                                onClick={primaryOnClick}
                            />
                        )
                    }
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmationModal;




// import React, { useState } from 'react';
// import { Button, Modal } from 'antd';
// import { useEffect } from 'react';

// const ConfirmationModal = ({
//     isOpen,
//     setIsOpen,
//     titleIconType,
//     titleIcon,
//     title,
//     description
// }) => {
//     console.log("isOPen:", isOpen);

//     const [isModalOpen, setIsModalOpen] = useState(isOpen);
//     console.log("isModalOpen:", isModalOpen);

//     const showModal = () => {
//         setIsModalOpen(true);
//     };

//     const handleOk = () => {
//         setIsModalOpen(false);
//     };

//     const handleCancel = () => {
//         setIsModalOpen(false);
//     };

//     useEffect(() => {
//         if (!isModalOpen) setIsOpen(false)
//     }, [isModalOpen])

//     return (
//         <>
//             <Modal
//                 title="Basic Modal"
//                 closable={{ 'aria-label': 'Custom Close Button' }}
//                 open={isModalOpen}
//                 onOk={handleOk}
//                 onCancel={handleCancel}
//             >
//                 <p>Some contents...</p>
//                 <p>Some contents...</p>
//                 <p>Some contents...</p>
//             </Modal>
//         </>
//     );
// };

// export default ConfirmationModal;